/**
 * Enum Tính BHYT
 * TVDAT 12.07.2022
 */
export default {
  All: -1,
  IsHealthInsurance: 1,
  NotIsHealthInsurance: 0,
};
